export default __webpack_public_path__ + "static/162-a444527ae9dd6f5629e53a2c3500fd9d.jpg";